<mat-card class="shadow-none bg-transparent">
  <mat-card-content class="bg-white rounded-2 p-4">


    <div class="d-flex justify-content-center align-items-end flex-wrap gap-4 flex-row">
      <div class="d-flex flex-column gap-4 justify-content-center flex-wrap">
        <div>
          <h4 style="font-weight: 400">
            <a class="d-flex m-0 align-items-center" href="https://t.me/jecrm_info" target="_blank" style="font-size: 18px;" [style.font-size]="!baseService.isMobile ? '18px' : '15px'">
              <img class="me-2" src="/assets/svgs/home/telegram.svg" style="background: #229ED9; border-radius: 50%; width: 30px;"/>
              <span>{{'answers_to_questions_in_our_group' | translate}}</span>
            </a>
          </h4>
        </div>
        <div>
          <h3 class="text-black">{{ 'part' | translate }} 1. {{ 'presentation' | translate }}</h3>
          <iframe
            class=" frame-video frame-video__dark img-fluid" width="640px" height="360px"
            src="https://www.youtube.com/embed/yoItYPLsW5k" allowfullscreen
            title="JECRM - розкрийте потенціал OLX. Частина 1. Презентація" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        </div>

      </div>
      <div class="align-content-center">
        <h3 class="text-black">{{ 'part' | translate }} 2. {{ 'functionality' | translate }}</h3>
        <iframe
          class="rounded-4 frame-video frame-video__dark img-fluid" width="640px" height="360px"
          src="https://www.youtube.com/embed/eJBZVdY9Bw0" allowfullscreen
          title="JECRM - розкрийте потенціал OLX. Частина 2. Функціонал" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        ></iframe>
      </div>

    </div>
  </mat-card-content>
</mat-card>
